export default __webpack_public_path__ + "static/media/logo__project__zenport.3d9974e1.png";